export default __webpack_public_path__ + "static/media/declarations-icon-black.a6976517.svg";